import React, { useCallback, useEffect, useState } from "react";

import { addArticle, getMethodNames, getModuleNames, getTags } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate } from "utils";

import { AdminHead, Button, Col, Form, MainPage, ModalContent, Row, Message as message } from "components";

import { ArticleInputs } from "pages/admin/content/components/ArticleInputs";

export const ArticleAdd = () => {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [methods, setMethods] = useState([]);
  const [modules, setModules] = useState([]);
  const [imageSuccess, setImageSuccess] = useState(false);
  const [imageURL, setImageURL] = useState(false);
  const [content, setContent] = useState("");
  const [showModal, setShowModal] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadTags = useCallback(
    (language) => {
      getTags({
        language,
        signal,
      })
        .then((res) => {
          setTags(res);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [signal]
  );

  const loadMethods = useCallback(() => {
    getMethodNames({
      signal,
    }).then((res) => {
      setMethods(res);
      loadTags();
    });
  }, [signal, loadTags]);

  const loadModules = useCallback(() => {
    getModuleNames({
      signal,
    }).then((res) => {
      setModules(res);
    });
  }, [signal]);

  const complete = (v) => {
    setLoading(true);

    addArticle({
      ...v,
      ...{ image: imageURL, content: content, methods: v.methods && [v.methods], modules: v.modules && [v.modules], signal },
    })
      .then(() => {
        navigate("/content/articles");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadMethods();
    loadModules();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage pageName={"admin"}>
      <AdminHead
        description={
          "Add a new article here. A URL will be automatically generated from the title and cannot be changed once saved. Only the first 3 tags are displayed, but all tags are searched."
        }
        link={"/content/articles"}
        title={"Add a new article"}
        tooltipText={"Back to articles"}
      />
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={complete} onFinishFailed={incomplete}>
            <ArticleInputs
              content={content}
              imageSuccess={imageSuccess}
              imageURL={imageURL}
              methods={methods}
              modules={modules}
              setContent={setContent}
              setImageSuccess={setImageSuccess}
              setImageURL={setImageURL}
              setLoading={setLoading}
              tags={tags}
              reloadTags={loadTags}
            />
            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading} className="margin-right-100">
                    Save
                  </Button>
                  <Button onClick={() => setShowModal(true)} disabled={loading} loading={loading}>
                    Preview content
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <ModalContent visible={showModal} type="article" onCancel={() => setShowModal(false)}>
        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
      </ModalContent>
    </MainPage>
  );
};
